import { PayloadAction } from '@reduxjs/toolkit';

export enum PushType {
  LIVE = 'LIVE',
  MESSAGE = 'MESSAGE',
}

export interface Push {
  id: number;
  createdAt: number;
  type: PushType;
  title: string;
  text: string;
  userId: number;
  ttl: number;
  objectId?: number;
}

export interface PushesState {
  items: Push[];
}

export type PushesPushAction = PayloadAction<{
  type: PushType;
  title: string;
  text: string;
  userId: number;
  objectId?: number;
  ttl?: number;
}>;

export type PushesCloseAction = PayloadAction<number>;
